import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateFormTemplate = ({
  Show,
  Hide,
  Title,
  getStudyDataEntry,
  getStudyFormTemplatesData,
  templateData,
  studyId,
  formId,
  libraryTemplate,
}) => {
  const [formData, setFormData] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (templateData) {
      setFormData(templateData?.dataEntry || {});
    }
  }, [templateData]);

  const updateStudyDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this data?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        const userData = {};
        userData.id = templateData?._id;
        userData.studyId = studyId;
        userData.formId = formId;
        userData.dataEntry = formData;

        const data = await cdiscManagementService.updateStudyDataEntry(
          userData
        );

        if (data?.statusCode === 200) {
          getStudyDataEntry();
          getStudyFormTemplatesData();
          setFormData({});
          Hide();
        }

        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {libraryTemplate?.map((item, index) => (
          <Form.Group className="mb-2" key={index}>
            <Form.Label className="mb-1 fw-bold">
              {item.label}{" "}
              {item.permission === "require" && (
                <span className="text-danger">*</span>
              )}
            </Form.Label>
            <Form.Control
              required={item.permission === "require"}
              type={item.type}
              value={formData[item.name] || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  [item.name]: e.target.value,
                })
              }
              placeholder={`Enter ${item.label}`}
            />
          </Form.Group>
        ))}
      </Offcanvas.Body>

      <div className="text-end p-2 border-top">
        <button
          onClick={updateStudyDataEntry}
          className="updateProfile"
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateFormTemplate;
